import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom-v5-compat';

import { Text, TextType } from 'ui-components/components/text';

import { usePurchaseOrderContext } from '../purchase-order-context';
import { PurchaseOrdersBaseRoute } from '../purchase-orders-routes';
import { messages } from './purchase-order-breadcrumb.messages';
import styles from './purchase-order-breadcrumb.styles.module.less';

/**
 * Purchase Order Breadcrumb component
 * Displays the breadcrumb navigation for the purchase order page
 * @returns {JSX.Element} The breadcrumb component
 */
export const PurchaseOrderBreadcrumb = () => {
  const { purchaseOrder } = usePurchaseOrderContext();
  const intl = useIntl();
  return (
    <div className={styles.breadcrumb}>
      <Link className={styles.link} to={PurchaseOrdersBaseRoute}>
        <Text className={styles['breadcrumb-font']} textType={TextType.Paragraph} value={messages.purchaseOrderBreadcrumb} />
      </Link>
      <Text
        className={styles['breadcrumb-font']}
        textType={TextType.Paragraph}
        value={intl.formatMessage(messages.purchaseOrder, {
          orderId: purchaseOrder.orderNumber,
        })}
      />
    </div>
  );
};
